module.exports = __webpack_public_path__ + "img/contact_us.6a8ff9ee.svg";